/**
 * 用户管理
 */
export default {
  // 用户列表
  userInfoList: "/userInfo/pageList", // 用户列表
  userChangeLevel: "/userInfo/changeLevel", // 用户等级调整
  userChangeFreeFlag: "/userInfo/updateFreeFlag", // 用户权限调整
  userBellowUser: "/userInfo/bellowUser", // 查看下级用户
  getUserMerchant: "/userInfo/getUserMerchant", // 用户分账详情
  merchantSet: "/userInfo/merchantSet", // 用户分账设置
  // 收益明细
  revenueList: "/orderIncome/pageList", // 用户分账设置
}
